export default {
    namespaced: true,
    state: {
        currentVideo: null,
        visualIfo: {
            id: '',
            title: '',
        },
        currentDetail: null,
        rourlurl: '',
    },
    mutations: {
        SET_CURRENT_VIDEO(state, video) {
            state.currentVideo = video;
        },
        SET_VIDEO_PROGRESS(state, progress) {
            if (state.currentVideo) {
                state.currentVideo.progress = progress;
            }
        }
    },
    actions: {
        setCurrentVideo({ commit }, video) {
            commit('SET_CURRENT_VIDEO', video);
        }
    }
}